<template>
    <div id="modal" class="modal fade" tabindex="-1">

        <div class="modal-dialog modal-xl modal-dialog-centered">

            <div class="modal-content">

                <div class="modal-body">

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    
                    <div class="container-fluid">

                        <div class="row">

                            <div class="col-sm-12 column">

                                <h2 class="column-title">Lesson Launcher Preview</h2>
                                <div id="preview">
                                    <div class="cortex-item">
                                        <div class="item">
                                            <h3>{{ vuwsName }}</h3>
                                        </div>
                                        <div class="details">
                                            <div class="vtbegenerated">
                                                <p v-if="beforeLauncher">
                                                    {{ beforeLauncher }}
                                                </p>
                                                <button class="learn2learn-vuws-item" :style="'--color-secondary: ' + backgroundColor + '; --color-primary: ' + buttonColor">
                                                    <span class="l2l-vuws-item-content">
                                                        <span class="l2l-title">Learn2Learn</span>
                                                        <span class="l2l-lesson-name">{{ lesson.title }}</span>
                                                        <span class="l2l-lesson-desc" v-text="lesson.vuws_item_desc"></span>
                                                        <span class="l2l-lesson-button">Start Lesson</span>
                                                    </span>
                                                    <span class="l2l-vuws-item-image">
                                                        <img :src="image" alt="Goal Setting">
                                                    </span>
                                                </button>
                                                <p v-if="afterLauncher">
                                                    {{ afterLauncher }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion" id="customise-launcher-container">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="customise-launcher-heading">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#customise-launcher" aria-expanded="false" aria-controls="collapseOne">
                                            Customise the Launcher
                                        </button>
                                        </h2>
                                        <div id="customise-launcher" class="accordion-collapse collapse" aria-labelledby="customise-launcher-heading" data-bs-parent="#customise-launcher-container">
                                            
                                            <form class="row">

                                                <div class="col-lg-6">

                                                    <div class="mb-3">
                                                        <label for="text-before">
                                                            <strong>Text before Lesson Launcher</strong>
                                                        </label>
                                                        <textarea id="text-before" cols="30" rows="3" class="form-control" v-model="beforeLauncher"></textarea>
                                                    </div>

                                                </div>

                                                <div class="col-lg-6">
                                                    
                                                    <div class="mb-3">
                                                        <label for="text-after">
                                                            <strong>Text after Lesson Launcher</strong>
                                                        </label>
                                                        <textarea id="text-after" cols="30" rows="3" class="form-control" v-model="afterLauncher"></textarea>
                                                    </div>

                                                </div>

                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12 column">

                                <!-- collpsable section -->
                                <div class="accordion collapsable-section" id="how-to-add">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="how-to-add-heading">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#how-to-add-content" aria-expanded="true" aria-controls="collapseOne">
                                                How to add a Learn2Learn lesson to your vUWS site
                                            </button>
                                        </h2>
                                        <div id="how-to-add-content" class="accordion-collapse collapse show how-to-add-content" aria-labelledby="how-to-add-heading" data-bs-parent="#how-to-add">

                                            <div class="row">

                                                <div class="col-lg-6">
                                                    <ol>
                                                        <li>
                                                            Log in to <a href="https://vuws.westernsydney.edu.au" target="_blank">vUWS</a> and go to your vUWS site
                                                        </li>
                                                        <li>
                                                            Ensure <strong>Edit mode</strong> is <strong>ON</strong>
                                                        </li>
                                                        <li>
                                                            Navigate to the content area where you would like to insert the lesson launcher
                                                        </li>
                                                        <li>
                                                            Hover over <strong>Build Content</strong> and click on <strong>item</strong>
                                                        </li>
                                                        <li>
                                                            Customise and preview the Lesson Launcher in the panel above (if desired)
                                                        </li>
                                                        <li>
                                                            Copy the vUWS item content information into the following fields within the vUWS Content Editor:<br>
                                                            <strong>Name</strong>: paste into the Name field<br>
                                                            <strong>Embed code</strong>: click on the &lt;&gt; (Source code) button and paste the embed code that is created into the provided field, and click Save.
                                                        </li>
                                                        <li>
                                                            Click <strong>Submit</strong>
                                                        </li>
                                                    </ol>
                                                </div>

                                                <div class="col-lg-6">
                                                    <div class="ratio ratio-16x9">
                                                        <iframe width="560" height="315" src="https://www.youtube.com/embed/TNj0Yh7RYD8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!-- end of collapsable section -->

                                <div class="row embed-codes">

                                    <div class="col-lg-6 d-flex justify-content-center align-items-center">

                                        <div class="row w-100">
                                            <label for="name" class="col-sm-11">
                                                    <strong>Name</strong>
                                            </label>
                                            <div class="col-sm-11">
                                                <input type="text"  @click="selectValuesInField($event)" id="name" class="form-control" v-model="vuwsName">
                                            </div>
                                            <div class="col-sm-1">
                                                <button class="btn copy-to-clipboard-btn" @click="copyToClipboard('name', $event)"><span class="button-tooltip">Copy to clipboard</span><font-awesome-icon :icon="['far', 'clone']" /></button>
                                            </div>                                        
                                        </div>

                                    </div>

                                    <div class="col-lg-6  d-flex justify-content-center align-items-center">

                                        <div class="row">
                                            <label for="embed-code" class="col-sm-11">
                                                <strong>Embed code</strong>
                                                <span class="embed-code-desc">
                                                    Click on &lt;&gt; button in the vUWS content editor and paste the embed code you see below
                                                </span>
                                            </label>
                                            <div class="col-sm-11">
                                                <textarea v-html="getEmbedCode()" @click="selectValuesInField($event)" name="embed-code" id="embed-code" cols="30" rows="8" class="form-control"></textarea>
                                            </div>
                                            <div class="col-sm-1">
                                                <button class="btn copy-to-clipboard-btn" @click="copyToClipboard('embed-code', $event)"><span class="button-tooltip">Copy to clipboard</span><font-awesome-icon :icon="['far', 'clone']" /></button>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div class="col-sm-12 column">

                                 <!-- collpsable section -->
                                <div class="accordion collapsable-section" id="additional-embed-options">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="additional-embed-options-heading">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#additional-embed-options-content" aria-expanded="false" aria-controls="collapseOne">
                                                How to track students’ review of Learn2Learn lesson
                                            </button>
                                        </h2>
                                        <div id="additional-embed-options-content" class="accordion-collapse collapse additional-embed-options-content" aria-labelledby="additional-embed-options-heading" data-bs-parent="#additional-embed-options">

                                            <div class="row">

                                                <div class="col-lg-6">
                                                    <p>
                                                        The Review Status tool allows instructors to track students’ review of specific content items. After an instructor turns on the tool for an item, in this case, an embedded lesson, a ‘Needs Review’ button appears with the items. After reviewing the item, a student selects this button to mark it ‘Reviewed’.
                                                    </p>
                                                    <p>
                                                        To view students' progress in vUWS, go to item you wish to view user progress for, and click the chevron that appears to the right of the item name. From the menu that appears, select ‘User Progress.’
                                                    </p>
                                                </div>

                                                <div class="col-lg-6">
                                                    <div class="ratio ratio-16x9">
                                                        <iframe width="560" height="315" src="https://www.youtube.com/embed/kj9RzjPCamE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!-- end of collapsable section -->

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: ["lesson", "image", "backgroundColor", "buttonColor"],
    data() {
        return {
            embedUrl: "https://lf.westernsydney.edu.au/embed/l2l-lesson/l2l-lesson-embed-script.min.js",
            iframe : {
                width: 1920,
                height: 280,
                src: "https://lf.westernsydney.edu.au/embed/l2l-lesson/l2l-lesson-embed.html",
                style: {
                    maxWidth: "100%"
                }
            },
            vuwsName: null,
            vuwsItemData: {
                lessonName: null,
                buttonColor: null,
                backgroundColor: null,
                image: null
            },
            beforeLauncher: null,
            afterLauncher: null
        }
    },
    watch: {
        lesson: function(newValue){
            if(newValue){
                this.vuwsName = "L2L " + this.lesson.title;
                this.vuwsItemData.lessonName = this.lesson.title;
                this.vuwsItemData.buttonColor = this.buttonColor;
                this.vuwsItemData.backgroundColor = this.backgroundColor;
                this.vuwsItemData.image = this.image;
            }
        }
    },
    methods: {
        getEmbedCode() {
            const embedFrame = `<iframe width="${this.iframe.width}" height="${this.iframe.height}" src="${this.iframe.src + "?cid=" + this.lesson.ID}" class="l2l-embed-lesson" data-l2l-sid="@X@course.id@X@" data-l2l-uid="@X@user.id@X@" data-l2l-cid="${this.lesson.ID}" style="max-width:${this.iframe.style.maxWidth};"></iframe>`;
            const embedScript = `&#x3C;script class=&#x22;l2l-embed-lesson-script&#x22; src=&#x22;${this.embedUrl}&#x22;&#x3E;&#x3C;/script&#x3E;`
            return `${this.beforeLauncher ? "<p>" + this.beforeLauncher + "</p>" : ""}<p>` + embedFrame + embedScript + `</p>${this.afterLauncher ? "<p>" + this.afterLauncher + "</p>" : ""}`;
        },
        selectValuesInField(event, el = undefined){
            event.preventDefault();

            if (typeof el === 'undefined')
                el = event.target;
            
            el.select();
            el.setSelectionRange(0, 99999);
        },
        copyToClipboard(elId, event){
            event.preventDefault();

            let btn = event.target;
            if (event.target.tagName != "BUTTON")
                btn = btn.closest("button");
            
            this.selectValuesInField(event, document.getElementById(elId));
            document.execCommand("copy");
            let tooltip = btn.querySelector(".button-tooltip");
            tooltip.innerText = "Copied!";
            setTimeout(function(){
                tooltip.innerText = "Copy to clipboard";
            }, 1000);
        }
    }

}
</script>

<style lang="scss" scoped>

    :root {
        --color-primary: #FFFFFF;
        --color-secondary: #FFFFFF;
    }
    
    #modal {

        *:focus {
            box-shadow: none;
        }

        .container-fluid {
            margin-top: 1.5rem;
            margin-bottom: 1.5rem;
        }

        .modal-content {

            .btn-close {
                position: absolute;
                left: calc(100% - 30px);
                bottom: calc(100% - 30px);
                background-color: var(--color-white);
                color: black;
                display: block;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                opacity: 1;
                box-shadow: 0 4px 4px 0 rgb(0 0 0 / 10%);
                transition: background-color 0.3s ease-in-out;

                &:hover {
                    cursor: pointer;
                    background-color: #F3F3F3;
                }

            }

            .column {
                &:first-child .column-title {
                    background-color: var(--color-teal-15);
                }
                &:last-child .column-title {
                    background-color: var(--color-crimson-15);
                }
                .column-title {
                    padding: 20px;
                    font-size: 16px;
                    color: var(--color-dark-grey);
                    border-radius: 5px;
                    margin-bottom: 20px;
                }
            }

            p, li {
                font-size: 16px;
            }

            ol li {
                margin-bottom: 15px;

                > ol li {
                    font-size: 15px;
                    margin-bottom: 5px;
                }
            }

            strong {
                font-family: $fontBold;
            }

            a {
                color: var(--color-crimson);
            }

            form {

                label {
                    margin-bottom: 0.5rem;
                }

                input[type=text], textarea {
                    border: 1px solid var(--color-dark-grey);
                    border-radius: 0;
                    font-size: 13px;
                }

                .form-control:focus {
                    border-color: var(--color-crimson);
                    box-shadow: none;
                }

            }

            .embed-form, .embed-codes {

                .col-sm-1 {
                    padding: 0;

                    .btn {
                        border: 1px solid var(--color-dark-grey);
                        font-size: 1.2rem;
                        padding: 0.1rem 0.5rem;
                        position: relative;

                        .button-tooltip {
                            display: block;
                            position: absolute;
                            top: -3rem;
                            left: 50%;
                            transform: translateX(-50%);
                            padding: 0.5rem 1rem;
                            background-color: rgba(0,0,0,0.8);
                            color: #FFFFFF;
                            width: max-content;
                            border-radius: 15px;
                            font-size: 0.8rem;
                            visibility: hidden;
                            opacity: 0;
                            transition: opacity 0.3s ease-in-out;

                            &::after {
                                content: "";
                                position: absolute;
                                top: 100%;
                                left: 50%;
                                margin-left: -10px;
                                border-width: 10px;
                                border-style: solid;
                                border-color: rgba(0,0,0,0.8) transparent transparent transparent;
                            }

                        }

                        &:hover {
                            background-color: var(--color-dark-grey);
                            color: #FFFFFF;

                            .button-tooltip {
                                visibility: visible;
                                opacity: 1
                            }

                        }
                    }

                }

            }

            .embed-code-desc {
                display: inline-block;
            }

        }

        #preview {

            background: #F3F3F3;
            padding: 1rem;

            .cortex-item {
                margin: 0 auto;
                min-height: 35px;
                max-width: 840px;
                background-color: #FFFFFF;
                box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 12%), 0px 2px 2px 0px rgb(0 0 0 / 24%);
                transition: box-shadow 0.2s ease;
                border: 1px solid #C4C4C4;
                font-family: "Open Sans",sans-serif !important;

                .item {
                    padding: 20px 50px 20px 60px;
                    height: auto;
                    border-bottom: 2px solid var(--color-crimson);

                    h3 {
                        display: inline;
                        line-height: 1.2;
                        color: var(--color-crimson);
                        font-size: 20px;
                        font-weight: normal;
                    }

                }

                .details {
                    padding: 0 25px;

                    .vtbegenerated {
                        margin: 25px 0;

                        p, li {
                            font-size: 14px;
                            line-height: 1.4;
                        }

                        .learn2learn-vuws-item:hover {
                            background-color: var(--color-secondary);
                            .l2l-lesson-name::after {
                                background-color: var(--color-secondary);
                            }
                            .l2l-lesson-button {
                                background-color: var(--color-primary);
                            }
                        }

                    }
                }

            }

        }

        #customise-launcher-container {

            .accordion-item, .accordion-button:not(.collapsed) {
                border: none;
            }

            .accordion-button:not(.collapsed) {
                background: none;
                color: inherit;
                box-shadow: none;
                &::after {
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
                }
            }

            #customise-launcher-heading {

                button {
                    padding-left: 0;
                    padding-right: 0;
                    color: inherit;
                    position: relative;
                    &:hover {
                        cursor: pointer;
                    }
                    &::before {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 200px;
                        right: 6%;
                        transform: translateY(-50%);
                        height: 1px;
                        background: #000000;
                    }
                }

            }

        }

        .embed-codes {
            margin: 2rem 0;
        }

        .how-to-add-content {

            background-color: var(--color-off-white);
            border-bottom: 1px solid #000000;
            border-radius: 0;

        }

        #how-to-add-content, #additional-embed-options-content {
            padding: 2rem;
        }

        .collapsable-section {

            .accordion-item {
                border-radius: 0;
                border: none;
            }

            .accordion-button {
                color: #000000;
                background-color: var(--color-crimson-15);
            }

            .accordion-button:not(.collapsed) {
                border: none;
                color: inherit;
                box-shadow: none;
                &::after {
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
                }
            }

        }

        .collapsable-section #additional-embed-options-heading button.accordion-button {
            background-color: var(--color-purple-15);
        }

        button.accordion-button {
            outline: none;
            &:focus {
                box-shadow: none;
            }
        }

    }
</style>